import { render, staticRenderFns } from "./WatchlistButton.vue?vue&type=template&id=31dba37a&scoped=true&"
import script from "./WatchlistButton.vue?vue&type=script&lang=js&"
export * from "./WatchlistButton.vue?vue&type=script&lang=js&"
import style0 from "./WatchlistButton.vue?vue&type=style&index=0&id=31dba37a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dba37a",
  null
  
)

export default component.exports